export enum ContactType {
  CONTACT = 'contact',
  INVOICE = 'invoice',
  DELIVERY = 'delivery',
  OTHER = 'other',
}

export function castContactTypeEnum(value: ContactType): string {
  switch (value) {
    case ContactType.CONTACT:
      return 'CUSTOMERS.CONTACT_TYPE_CONTACT';
    case ContactType.INVOICE:
      return 'CUSTOMERS.CONTACT_TYPE_INVOICE';
    case ContactType.DELIVERY:
      return 'CUSTOMERS.CONTACT_TYPE_DELIVERY';
    case ContactType.OTHER:
      return 'CUSTOMERS.CONTACT_TYPE_OTHER';
  }
}
